import {Component, OnInit, Input, ViewChild} from '@angular/core';
import { User }    from '../../../shared/login/user';
import { AccountService } from '../account.service';
import {EventsService} from "../../../bo/events/events.service";
import {FonctionUtiles} from "../../fonctionsUtiles";
import {CropModalComponent} from "../../../bo/events/crop-modal/crop-modal.component";
import {CropperSettings} from "ngx-img-cropper";
import {Payement} from "../../../bo/organization/payment";
import {Userdocument} from "../userdocument";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  providers: [AccountService], //TODO #LOW provider in module or parent component doesnt work?!
})
export class ProfileComponent implements OnInit {
  errorMsg : any = '';
  hasPwd = false;
  submitted = false;
  success = false;
  birthdayMax:any;
  changPassword:boolean = true;
  telDialcode:any;
  dataSaved: boolean = false;
  cropperBannerSettings: CropperSettings;
  bannerModalindex = -1;
  bannerModalname = "banne";
  editningAvatar:boolean = false;
  tel:any;
  locationCountryCode:any;
  blocs:any =  {profilDataIsActive : true,profilDocumentIsActive :false,profilRibIsActive:false};
  ribBlocs: any =  {ribPassword : true,noRibAddRib :false,ribList:false,ribForm:false};
  documentBlocs: any = {pieceIdentityTypeList: true,uploadIdentityFile: false,identityConfirmForm: false,confirm:false};
  documentTypeMaps = {identityCard: 'carte d\'identite nationnale', passePort: 'passeport',
    driverLicence: 'permis de conduire', residencePermit: 'titre de séjour'};
  documentUploadedIsValidated = false;
  sameDocumentRectoVerso = false;
  passwordEmail = {email:'', password:''};
  incorrectPasswordError: boolean = false;
  payment: Payement = new Payement();
  userDocument: Userdocument = new Userdocument();
  isRecto = true;
  confirmDocumentNotExpired = false;
  errors: any = [];
  payementErrors: any = [];
  @ViewChild('cropperModal') cropperModal:CropModalComponent;

  confirmDocumentNotExpiredChange(values:any) {
    this.confirmDocumentNotExpired = values.currentTarget.checked;
  }
  onSubmitUploadConfirm(validity) {
    if(validity){

    }
  }
  goToBlocItem(bloc) {
    this.setBloc(bloc)
  }
  documentType(str): string {
    return this.documentTypeMaps[str];
  }

  blocIsVisible(bloc) {
    return this.blocs[bloc];
  }
  sameDocumentRectoVersoChange(values:any):void {
    this.userDocument.isRectoVerso = values.currentTarget.checked;
  }
  ribBlocIsVisible(bloc) {
    return this.ribBlocs[bloc];
  }
  documentsBlocIsVisible(bloc) {
    return this.documentBlocs[bloc];
  }
  goToRibBlocItem(bloc) {
    this.setRibBloc(bloc)
  }
  goToDocumentBlocItem(bloc,type?) {
    this.setDocumentBloc(bloc);
    if(type) {
      this.userDocument.type = type;
      this.userDocument.user_id = this.user.id;
    }
  }
  saveDocumentData(e) {
    e.preventDefault();
    e.stopPropagation();
    this.accountService.saveDocument(this.userDocument).then(res => {
      console.log(res);
      this.userDocument = res;
      this.goToDocumentBlocItem('confirm');

    })
  }
  setBloc(bloc) {
    for (let key in this.blocs) {
      this.blocs[key] = false;
    }
    this.blocs[bloc] = true;
  }

  setRibBloc(bloc) {
    for (let key in this.ribBlocs) {
      this.ribBlocs[key] = false;
    }
    this.ribBlocs[bloc] = true;
  }

  setDocumentBloc(bloc) {
    for (let key in this.documentBlocs) {
      this.documentBlocs[key] = false;
    }
    this.documentBlocs[bloc] = true;
  }

  hideAllBlocItem(){
    for (let key in this.blocs) {
      this.blocs[key] = false;
    }
  }
  editRib() {
    this.goToRibBlocItem('ribForm');
    this.accountService.loadUserPaymentInfo(this.user.id).then(res => {
      console.log('ok');
      this.payment = res;
    })
  }

  getInitial(str) {
    return this.functionUtils.getInitials(str);
  }

  editPassword(e) {
    e.preventDefault();
    this.changPassword = false;
  }
  initCropBanner() {
    this.cropperBannerSettings = new CropperSettings();
    this.cropperBannerSettings.noFileInput = true;
    this.cropperBannerSettings.width = 300;
    this.cropperBannerSettings.height = 300;
    this.cropperBannerSettings.minWidth = 200;
    this.cropperBannerSettings.minHeight = 200;
    this.cropperBannerSettings.minWithRelativeToResolution = true;
    this.cropperBannerSettings.croppedWidth = 70;
    this.cropperBannerSettings.croppedHeight = 70;
    this.cropperBannerSettings.canvasWidth = 250;
    this.cropperBannerSettings.canvasHeight = 250;
  }
  /*errors = _('front_profil.errorMessage');*/

  @Input() user: User;
  constructor(private functionUtils:FonctionUtiles,private accountService: AccountService,private eventService: EventsService) {

    this.initCropBanner();
    let date = new Date();
    date.setFullYear( date.getFullYear() - 17 );
    date.setMonth(0);
    date.setDate(1);
    console.log(date);
    //this.birthdayMax = new DatePipe("fr-FR").transform(date, 'yyyy-MM-dd');
  }

  ngOnInit() {
    // try to hack the defualt selected option
    this.onChangeGender(this.user.gender);
    this.loadIp().then(res => {
      if(res)
        this.locationCountryCode = res.countryCode.toLowerCase();
      else
        this.locationCountryCode = 'gp';
      this.setTelWidth();
    });
    // this.loadUserDocument();
  }
  loadUserDocument() {
    this.accountService.loadUserDocument(this.user.id).then(res => {
      // console.log(res);
      if(res && res.id) {
        this.userDocument = res;
        this.goToDocumentBlocItem('confirm');
      }
    });
  }
  editPicBtn(e) {
    e.preventDefault();
    e.stopPropagation();
    let $ = window['jQuery'];
    $('#edit-pic-btn').click();
    return;
  }
  userAvatarFileListenner($event) {
    let image: any = new Image();
    let file: File = $event.target.files[0];
    let myReader: FileReader = new FileReader();
    let that = this;
    this.editningAvatar = true;
    myReader.onloadend = function (loadEvent: any) {
      image.src = loadEvent.target.result;
      image.onload = (e) => {
        console.log('ok');
        that.cropperModal.showModal();
        that.cropperModal.setCrop(image);
        /* that.cropperBanner.setImage(image);*/
      }
    };
    myReader.readAsDataURL(file);
  }
  userIsMale(user) {
    return this.functionUtils.userIsMale(user);
  }

  setTelWidth() {
    setTimeout(function () {
      let $ = window['jQuery'];
      $('.iti').width('100%');

      let oinput1 = $('.oinput');
      if(oinput1.length){
        /*  console.log(oinput1);
          console.log(oinput1.attr("placeholder"));*/
        if(oinput1.attr("placeholder") && !oinput1.attr("placeholder").includes('ex'))
          oinput1.attr("placeholder","ex: "+oinput1.attr("placeholder"));
      }
    },1000)
  }

  onChangeGender(value) {
    this.user.gender = (value) ? value : '';
    console.log("change", value);
  }

  loadIp() {
    return this.eventService.getIp();
  }

  onRibSubmit(validity) {}

  onSubmit(validity) {
    this.errorMsg = '';
    if(this.cropperModal.Imgdata.image) {
      this.user.avatar = this.cropperModal.Imgdata.image;
    }
    if(validity && this.hasValidPwd()) {
      this.doRequest();
    } else {
      this.errorMsg = this.errors;
      return false;
    }

  }
  openDownloadIban() {
    let $ = window['jQuery'];
    $('#download_iban').click();
  }


  iban_bic_download_FileListenner($event) {
    let file: File = $event.target.files[0];
    let myReader: FileReader = new FileReader();
    let that = this;
    myReader.onloadend = function (loadEvent: any) {
      that.payment.rib_iban_pdf = loadEvent.target.result;
    };
    myReader.readAsDataURL(file);
  }

  createOrUpdatePayment(e) {
    e.preventDefault();
    e.stopPropagation();
    this.payment.devise = 'EUR';
    this.payment.user_id = this.user.id;
    this.accountService.createPayement(this.payment).then(res => {
      this.payment = res;
      this.goToRibBlocItem('ribList');
    });
  }
  displayBic(bic) {
    let bicFormated = '';
    for (let i = 0; i < bic.length; i++) {
      if(i<=7) {
        bicFormated += bic[i];
      } else {
        bicFormated += 'X';
      }
    }
    return bicFormated;
  }
  displayIban(iban) {
    let ibanFormated = '';
    for (let i = 0; i < iban.length; i++) {
      if(i>3 && i<14) {
        ibanFormated += 'X';
      } else {
        ibanFormated += iban[i];
      }
    }
    return ibanFormated;
  }
  unlockWithPassWord() {
    this.passwordEmail.email = this.user.email;
    this.accountService.unlockWithPassWord(this.passwordEmail).then(res => {
      console.log(res);
      if(res === 'incorret') {
        this.incorrectPasswordError = true;
      } else {
        this.incorrectPasswordError = false;
        if(res.organisation && res.organisation.id != 2 && res.organisation.payment) {
          this.payment = res.organisation.payment;
          this.goToRibBlocItem('ribList');
        } else {
          this.goToRibBlocItem('noRibAddRib');
        }
      }
    })
  }

  private doRequest() {
    // ensure null pwd while reset is not active
    if(!this.hasPwd) this.user.password = '';
    // submit
    console.log('filled form', this.user);
    this.accountService.updateProfile(this.user).then(res=> {
      console.log(res);
      this.user = res;
      this.success = true;
      // make message disappear after 2s
      setTimeout(function(){ this.success = true; }, 2000);
    }).catch(error => {
      console.log(error);
      this.errorMsg = (error.msg) ? error.msg : error;
    })
  }

  tooglePwd($event) {
    this.hasPwd = (this.hasPwd) ? false : true;
  }


  setPhone() {

  }

  hasValidPwd() {
    // if user password doesnt exist set to empty #TODO: LOW - init in user class ?or constructor ?
    if(!this.user.password) this.user.password = '';
    if (this.hasPwd && this.user.password.length < 8) return false;
    return true;
  }

  onCountryChange(code) {
    console.log('country change');
    console.log(code);
  }

  getNumber(number) {
    if(number)
      this.user.phone = number;
    else
      alert('Vueillez saisir un numéro correct');
  }

  hasError(er) {
    if(er) {
      console.log(er)
    }
    else {
      alert('Vueillez saisir un numéro correct');
    }
  }

  telInputObject(obj) {
    // console.log(this.user);
    if(this.user.phone && this.user.phone.includes('+')) {
      if(obj)
        obj.setNumber(this.user.phone);
    } else {
      if(obj)
        obj.setCountry(this.locationCountryCode);
    }
  }

  continueToConfirmDocumentForm() {
    if(this.confirmDocumentNotExpired) {
      if(this.userDocument.isRectoVerso) {
        if(!this.userDocument.pathrectoverso) {
          alert('Vous devez télécharger un document');
        } else {
          this.goToDocumentBlocItem('identityConfirmForm')
        }
      } else {
        if(!this.userDocument.pathverso && !this.userDocument.pathrecto) {
          alert('Vous devez télécharger un document');
        } else {
          this.goToDocumentBlocItem('identityConfirmForm')
        }
      }
    } else {
      alert('Vous devez confirmer que votre document d\'identité n\'est pas expiré et est mis en couleurs.')
    }
  }
  unLockRibShowPassword() {

  }
  openRectoFile(e) {
    e.preventDefault();
    e.stopPropagation();
    this.isRecto = true;
    let $ = window['jQuery'];
    $('#recotVerso').click();
    return;
  }
  openVersoFile(e) {
    e.preventDefault();
    e.stopPropagation();
    this.isRecto = false;
    let $ = window['jQuery'];
    $('#recotVerso').click();
    return;
  }
  openRectoVersoFile(e) {
    e.preventDefault();
    e.stopPropagation();
    let $ = window['jQuery'];
    $('#recotVerso').click();
    return;
  }
  rectoVersoFileListenner($event) {
    let file: File = $event.target.files[0];
    console.log(file);
    if (file.type === 'application/pdf') {
      this.userDocument.isPdf = true;
    } else if (file.type === 'image/jpeg' || file.type === 'image/png') {
      this.userDocument.isPdf = false;
    } else {
      alert('format invalid');
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      console.log(reader.result);
      if (this.userDocument.isRectoVerso) {
        this.userDocument.pathrectoverso = reader.result.toString();
      } else {
        if(this.isRecto) {
          this.userDocument.pathrecto = reader.result.toString();
        } else {
          this.userDocument.pathverso = reader.result.toString();
        }

      }
    }
  }
}
